import styled from 'styled-components'
import { media } from '../../config/settings/media'

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 1.15rem 1.15rem 1rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
`

export const MonthGrid = styled.div`
  display: grid;
  gap: 0.55rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${media.sm`
    grid-template-columns: repeat(4, minmax(0, 1fr));
  `}
`

export const MonthCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-height: 76px;
  min-width: 0;
  padding: 0.7rem 0.75rem;
  border-radius: 10px;
  border: 1px solid
    ${({ $current, $empty, theme }) => {
      if ($current) return `${theme.colors.action.primary.bg}77`
      if ($empty) return theme.colors.borderDefault
      return theme.colors.borderDefault
    }};
  background: ${({ $current, $empty, theme }) => {
    if ($current) {
      return theme.name === 'dark'
        ? 'rgba(62, 207, 142, 0.14)'
        : 'rgba(62, 207, 142, 0.08)'
    }
    if ($empty) {
      return theme.name === 'dark'
        ? theme.colors.background
        : theme.colors.borderSubtle
    }
    return theme.colors.backgroundSecondary
  }};
`

export const MonthName = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ $current, theme }) =>
    $current ? theme.colors.action.primary.bg : theme.colors.textSecondary};
`

export const MonthValue = styled.span`
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-variant-numeric: tabular-nums;
`

export const MonthEmpty = styled.span`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const MonthTag = styled.span`
  align-self: flex-start;
  margin-top: auto;
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.action.primary.bg};
`

export const MonthSource = styled.span`
  font-size: 0.6875rem;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.35rem 0 0.15rem;
`

export const EmptyHint = styled.span`
  font-size: 0.8125rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const ErrorText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.action.danger.bg};
`
